import { Tab, TabList, TabPanel, TabPanels, Tabs } from '@chakra-ui/react'

import { PageTitle } from '../../../components/PageTitle'
import PopularPostsPage from './PopularPostsPage/PopularPostsPage'
import PostsPage from './PostsPage/PostsPage'

export default function BlogPostPage() {
  return (
    <>
      <PageTitle title="Posts do Blog" description="Publicações e destaques do blog da ABRA" />

      <Tabs isLazy>
        <TabList>
          <Tab>Postagens</Tab>
          <Tab>Posts Populares</Tab>
        </TabList>

        <TabPanels>
          <TabPanel>
            <PostsPage />
          </TabPanel>
          <TabPanel>
            <PopularPostsPage />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </>
  )
}
